import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Phone, CalendarCheck, ClipboardCheck, Plus } from "lucide-react";
import { whatsappUrl, PHONE_TEL } from "@/data/site";

const Mini = ({ as: C = "a", icon: I, label, className, testid, ...p }) => (
  <C {...p} aria-label={label} data-testid={testid} className="group flex items-center justify-end gap-3">
    <span className="rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-navy shadow-premium">{label}</span>
    <span className={`grid h-12 w-12 place-items-center rounded-full text-white shadow-lg transition-transform group-hover:scale-105 ${className}`}><I className="h-5 w-5" /></span>
  </C>
);

export const FloatingActions = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3" data-testid="floating-actions">
      <div className={`flex flex-col items-end gap-3 transition-[opacity,transform] duration-300 ${open ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"}`} aria-hidden={!open}>
        <Mini as={Link} to="/eligibility-check" icon={ClipboardCheck} label="Free eligibility check" className="bg-brand-blue" testid="float-eligibility-btn" onClick={() => setOpen(false)} tabIndex={open ? 0 : -1} />
        <Mini as={Link} to="/free-consultation" icon={CalendarCheck} label="Free consultation" className="bg-brand-red" testid="float-consultation-btn" onClick={() => setOpen(false)} tabIndex={open ? 0 : -1} />
        <Mini href={`tel:${PHONE_TEL}`} icon={Phone} label="Call us" className="bg-navy" testid="float-call-btn" tabIndex={open ? 0 : -1} />
      </div>
      <div className="flex items-center gap-3">
        <button onClick={() => setOpen((o) => !o)} aria-label={open ? "Close quick actions" : "Open quick actions"} aria-expanded={open} data-testid="float-toggle-btn"
          className="grid h-12 w-12 place-items-center rounded-full bg-white text-navy shadow-premium ring-1 ring-line transition-transform hover:scale-105">
          <Plus className={`h-5 w-5 transition-transform duration-300 ${open ? "rotate-45" : ""}`} />
        </button>
        <a href={whatsappUrl()} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp" data-testid="whatsapp-float-btn"
          className="group flex items-center gap-2 rounded-full bg-[#25D366] p-4 text-white shadow-[0_12px_30px_rgba(37,211,102,.35)] transition-transform hover:scale-105">
          <MessageCircle className="h-6 w-6" />
          <span className="hidden max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-[max-width] duration-300 group-hover:max-w-[160px] md:inline">Chat on WhatsApp</span>
        </a>
      </div>
    </div>
  );
};
